<template>
	<div>
		<div class="userBox">
			<div class="userQuery">
				<!-- 搜索 -->
				<el-input size="medium" placeholder="权限名称" v-model="roleName" class="input-with-select">
					<el-button @click="queryName" slot="append" icon="el-icon-search"></el-button>
				</el-input>
				<el-button size="medium" type="primary" style="" @click="addOpenForm">创建角色</el-button>
			</div>
			<div class="userTable">
				<el-table v-loading="loading" border :data="tableData" style="width: 100%" height="550">
					<el-table-column align="center" fixed prop="roleName" label="权限名称"></el-table-column>
					<el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
					<el-table-column align="center" prop="des" label="备注"></el-table-column>
					<el-table-column fixed="right" label="操作" width="180" align="center">
						<template slot-scope="scope">
							<el-link type="primary" :underline="false" style="margin-right: 10px;" @click="updateState(scope.row)">编辑</el-link>
							<el-link type="primary" :underline="false" style="margin-right: 10px;" @click="updateVipTime(scope.row.id)">分配</el-link>
							<el-popconfirm title="确定删除吗？" @confirm="delUserInfo(scope.row.id)">
								<el-link type="primary" :underline="false" slot="reference" style="margin-right: 10px;">删除角色</el-link>
							</el-popconfirm>

							<!-- <el-button @click="updateState(scope.row)" type="text" size="small">编辑</el-button> -->
							<!-- <el-button @click="updateVipTime(scope.row.id)" type="text" size="small">分配</el-button>
							<el-popconfirm title="确定删除吗？" @confirm="delUserInfo(scope.row.id)">
								<el-button slot="reference" style="margin-left: 10px;" type="text" size="small">删除角色</el-button>
							</el-popconfirm> -->
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="inPagination.currentPage"
					:page-sizes="[10, 50, 100, 200, 300, 400]"
					:page-size="inPagination.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="inPagination.total"
					class="pagination"
				></el-pagination>
			</div>
		</div>
		<!-- 手动添加 -->
		<el-dialog :title="userTitle" :close-on-click-modal="!1" :close-on-press-escape="!1" :visible.sync="dialogAddFormVisible">
			<el-form label-position="right" label-width="80px"  :model="add_form" ref="add_form" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="角色名称" prop="roleName"><el-input v-model="add_form.roleName" autocomplete="off" maxlength="20" show-word-limit></el-input></el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="备注"><el-input v-model="add_form.des" autocomplete="off" maxlength="20" show-word-limit></el-input></el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="resetForm('add_form')">取 消</el-button>
				<el-button size="medium" type="primary" @click="handleAddInterviewerPeople('add_form')">确 定</el-button>
			</div>
		</el-dialog>

		<el-drawer title="权限分配" :visible.sync="drawer" :direction="direction">
			<div class="jurisdiction">
				<el-tree
					ref="tree"
					:data="data"
					show-checkbox
					node-key="id"
					@node-click="nodeClick"
					:default-checked-keys="checkedKeys"
					:props="defaultProps"
					:expand-on-click-node="false"
				></el-tree>
				<!-- :default-expanded-keys="expandedKeys" -->
				<div class="jurisdictionFoot">
					<div></div>

					<div>
						<el-button @click="drawer = false">取消</el-button>
						<el-button @click="SaveAndClose(1)">仅保存</el-button>
						<el-button type="primary" @click="SaveAndClose(2)">保存并关闭</el-button>
					</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
export default {
	data() {
		return {
			roleId: '',
			nodeKey: '',
			expandedKeys: [],
			checkedKeys: [],
			data: [],
			defaultProps: {
				children: 'children',
				label: 'name'
			},
			drawer: false,
			direction: 'rtl',
			userTitle: '添加角色',
			userType: 1,
			add_form: {},
			rules: {
				roleName: [
					{ required: true, message: '请输入角色名称！', trigger: 'blur, change' },
				],
			},
			dialogAddFormVisible: false,
			loading: false,
			tableData: [],
			roleName: '',
			inPagination: {
				currentPage: 1,
				size: 10,
				total: 100
			}
		};
	},
	created() {
		this.loadData();
		this.queryPermission();
	},
	methods: {
		queryPermission() {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.queryPermission}`,
				data: {
					fatherId: ''
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						that.data = res.resultBody;
					} else {
						that.data = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		SaveAndClose(type) {
			let permissionId = this.$refs.tree.getCheckedKeys();
			let admin1001 = permissionId.filter(element => element == 1001);
			let admin1002 = permissionId.filter(element => element == 1002);
			let admin1003 = permissionId.filter(element => element == 1003);
			let admin1004 = permissionId.filter(element => element == 1004);
			let admin1005 = permissionId.filter(element => element == 1005);
			// 我的问卷 选中子节点 数组加入父节点
			if (admin1001.length == 0) {
				//没有找到
				if (
					permissionId.indexOf('1006') == -1 &&
					permissionId.indexOf('1007') == -1 &&
					permissionId.indexOf('1008') == -1 &&
					permissionId.indexOf('1009') == -1 &&
					permissionId.indexOf('1010') == -1 &&
					permissionId.indexOf('1011') == -1 &&
					permissionId.indexOf('1012') == -1 &&
					permissionId.indexOf('1013') == -1 &&
					permissionId.indexOf('1014') == -1 &&
					permissionId.indexOf('1015') == -1 &&
					permissionId.indexOf('1016') == -1 &&
					permissionId.indexOf('1017') == -1
				) {
					console.log('不存在');
				} else {
					permissionId.push('1001');
					console.log('存在,索引是：');
				}
			}
			// 我的考试
			if (admin1002.length == 0) {
				//没有找到
				if (
					permissionId.indexOf('1018') == -1 &&
					permissionId.indexOf('1019') == -1 &&
					permissionId.indexOf('1020') == -1 &&
					permissionId.indexOf('1021') == -1 &&
					permissionId.indexOf('1022') == -1 &&
					permissionId.indexOf('1023') == -1 &&
					permissionId.indexOf('1024') == -1 &&
					permissionId.indexOf('1025') == -1
				) {
					console.log('不存在');
				} else {
					permissionId.push('1002');
					console.log('存在,索引是：');
				}
			}
			// 问卷模板
			if (admin1003.length == 0) {
				//没有找到
				if (
					permissionId.indexOf('1026') == -1 &&
					permissionId.indexOf('1027') == -1 &&
					permissionId.indexOf('1028') == -1 &&
					permissionId.indexOf('1029') == -1 &&
					permissionId.indexOf('1030') == -1 &&
					permissionId.indexOf('1031') == -1 &&
					permissionId.indexOf('1032') == -1
				) {
					console.log('不存在');
				} else {
					permissionId.push('1003');
					console.log('存在,索引是：');
				}
			}
			// 考试题库
			if (admin1004.length == 0) {
				//没有找到
				if (permissionId.indexOf('1033') == -1 && permissionId.indexOf('1034') == -1) {
					console.log('不存在');
				} else {
					permissionId.push('1004');
					console.log('存在,索引是：');
				}
			}
			// 用户管理
			if (admin1005.length == 0) {
				//没有找到
				if (permissionId.indexOf('1035') == -1 && permissionId.indexOf('1036') == -1) {
					console.log('不存在');
				} else {
					permissionId.push('1005');
					console.log('存在,索引是：');
				}
			}

			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.addRolePermission}`,
				data: {
					roleId: this.roleId,
					permissionId: JSON.stringify(permissionId)
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						if (type == 2) {
							that.drawer = false;
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},

		nodeClick(data) {
			console.log('data', data);
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.queryPermission}`,
				data: {
					fatherId: data.id
				},
				cb(res) {
					if (res.code == 0) {
						let newData = JSON.parse(JSON.stringify(that.data));
						newData.forEach(item => {
							if (item.id == data.id) {
								console.log(res.resultBody);
								item.children = res.resultBody;
							}
						});
						that.data = newData;
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		updateVipTime(id) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.queryRolePermission}`,
				data: {
					roleId: id
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						that.roleId = id;
						if (res.resultBody != '') {
							let checkedKeys = JSON.parse(res.resultBody.permissionId);
							if (checkedKeys.indexOf('1001') != -1) {
								checkedKeys.splice(checkedKeys.indexOf('1001'), 1);
							}
							if (checkedKeys.indexOf('1002') != -1) {
								checkedKeys.splice(checkedKeys.indexOf('1002'), 1);
							}
							if (checkedKeys.indexOf('1003') != -1) {
								checkedKeys.splice(checkedKeys.indexOf('1003'), 1);
							}
							if (checkedKeys.indexOf('1004') != -1) {
								checkedKeys.splice(checkedKeys.indexOf('1004'), 1);
							}
							if (checkedKeys.indexOf('1005') != -1) {
								checkedKeys.splice(checkedKeys.indexOf('1005'), 1);
							}
							that.checkedKeys = checkedKeys;
						}
						that.nodeClick({id:'1001'})
						that.nodeClick({id:'1002'})
						that.nodeClick({id:'1003'})
						that.nodeClick({id:'1004'})
						that.nodeClick({id:'1005'})
						that.drawer = true;
					} else {
						that.checkedKeys = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		delUserInfo(id) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.removeRole}`,
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.$message.success(res.message);
						that.loadData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		updateState(data) {
			this.add_form = JSON.parse(JSON.stringify(data));
			this.userTitle = '编辑角色';
			this.userType = 2;
			this.dialogAddFormVisible = true;
		},
		addOpenForm() {
			this.add_form = {
				roleName: '',
				des: ''
			};
			this.userType = 1;
			this.userTitle = '添加角色';
			this.dialogAddFormVisible = true;
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogAddFormVisible = false
		},
		handleAddInterviewerPeople(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let that = this;
					let url = `${this.$config.service.addRole}`;
					if (this.userType == 1) {
						url = `${this.$config.service.addRole}`;
					} else {
						url = `${this.$config.service.modifyRole}`;
					}
					if (that.add_form.roleName == '') {
						that.$message.warning('请输入角色名称');
						return false;
					}
					let params = {
						that: this,
						method: 'POST',
						url: url,
						data: that.add_form,
						cb(res) {
							if (res.code == 0) {
								that.add_form = {};
								that.$message.success(res.message);
								that.loadData();
								that.resetForm(formName)
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			
		},
		queryName() {
			this.loadData();
		},
		loadData() {
			this.loading = true;
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.queryRole}`,
				data: {
					pageIndex: that.inPagination.currentPage,
					pageSize: that.inPagination.size,
					roleName: that.roleName
				},
				cb(res) {
					if (res.code == 0) {
						that.loading = false;
						that.tableData = res.resultBody.records;
						that.inPagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						that.$message.error(res.message);
						that.loading = false;
					}
				}
			};
			this.$util.request(params);
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.inPagination.size = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.inPagination.currentPage = val;
			this.loadData();
		}
	}
};
</script>

<style scoped lang="scss">
.userBox {
	// width: 1200px;
	// margin: 0px auto;
	// padding: 20px 20px 20px 20px;

	.userQuery {
		display: flex;
		justify-content: space-between;
		.input-with-select {
			width: 300px;
			margin-right: 20px;
		}
	}
	.userTable {
		margin-top: 20px;
		.pagination {
			margin-top: 20px;
			text-align: right;
		}
	}
}
.jurisdiction {
	padding: 10px;
	height: 100%;
	position: relative;
	.jurisdictionFoot {
		width: 100%;
		position: absolute;
		bottom: 20px;
		right: 20px;
		display: flex;
		justify-content: space-between;
	}
}
</style>
